import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { isType } from './isType'

export const isDownloadActionTreeRight = (
  actionModel?: WpsRuntime.atv.wps.DownloadActionTreeModelProps
): actionModel is WpsRuntime.atv.wps.DownloadActionTreeRightProps =>
  isType(actionModel, 'atv.wps#DownloadActionTreeRight')

const getMainDownload = (
  downloadActions?: WpsRuntime.atv.wps.DownloadActionsModelProps
) => downloadActions && downloadActions.main && isDownloadActionTreeRight(downloadActions.main) && downloadActions.main

export const getFirstDownloadData = (
  downloadActions?: WpsRuntime.atv.wps.DownloadActionsModelProps
) => {
  const mainDownload = getMainDownload(downloadActions)
  return mainDownload && mainDownload.children && mainDownload.children[0] || undefined
}

